<template>
    <div>
        <page-title
            :title="$t('deletedRecords.deletedEvents')"
            :showTitle="false"
        />
        <div class="card">
            <div class="card-header bg-primary text-white">
                <div class="h5 m-0">{{ $t('deletedRecords.deletedEvents') }}</div>
            </div>
            <div class="card-body p-0">
                <deleted-events-grid>
                </deleted-events-grid>
            </div>
        </div>
    </div>
</template>

<script>
import DeletedEventsGrid from '@/components/dynamic/events/DeletedEventsGrid';
import PageTitle from '@/components/common/PageTitle';

export default {
    components: { PageTitle, DeletedEventsGrid }
}
</script>
